import React, { useState } from 'react'

const FilterComponent = ({ filterList, onChange, index, column, filterOptions }) => {
  const [tempFilters, setTempFilters] = useState(filterList[index] || [])

  const handleChange = (event) => {
    const { value, checked } = event.target
    setTempFilters((prev) => {
      if (checked) return [...prev, value]
      return prev.filter((item) => item !== value)
    })
  }

  const handleApply = () => {
    onChange(tempFilters, index, column)
  }

  const handleReset = () => {
    setTempFilters([])
    onChange([], index, column)
  }

  return (
    <div style={{ padding: 16 }}>
      <div style={{ marginBottom: 10 }}>
        <button onClick={handleApply} className="apply-button-for-sast-sca">
          Apply
        </button>
        <button onClick={handleReset} className="reset-button-for-sast-sca">
          Reset
        </button>
      </div>

      {(filterOptions?.applications || []).map((option, i) => (
        <div
          key={i}
          className="filter-cont-for-sast-sca"
          style={{
            backgroundColor: tempFilters.includes(option) ? '#f0f0f0' : 'transparent',
          }}
          // onClick={() => {
          //   const newFilters = tempFilters.includes(option)
          //     ? tempFilters.filter((item) => item !== option)
          //     : [...tempFilters, option]
          //   setTempFilters(newFilters)
          // }}
        >
          <input
            type="checkbox"
            value={option}
            checked={tempFilters.includes(option)}
            onChange={handleChange}
            className="filter-checkbox-for-sast-sca"
          />
          <span className="filter-content-for-sast-sca">{option}</span>
        </div>
      ))}
    </div>
  )
}

export default FilterComponent
